// noinspection JSUnresolvedReference

import React, {useEffect, useState} from "react";
import useAuthorityConfiguration from "../../../../../api/utilities/useAuthorityConfiguration.js";
import {ErpCalculationApi} from "../../../../../api/authority/generated/index";
import {useTranslation} from "react-i18next";
import LoadingComponent from "../../../../../components/LoadingComponent.jsx";
import DoughnutChart from "../../../../../mosaic/charts/DoughnutChart.jsx";
import {getContrastBackgroundColors, getContrastBackgroundHoverColors} from "../../../../../utils/graphColors.js";

export default function DailyPaymentPerformance({title, day, project}) {

    let {t} = useTranslation();

    let [data, setData] = useState(null);

    let authorityConfiguration = useAuthorityConfiguration();
    let dayKey = day.format('YYYY-MM-DD');

    useEffect(() => {
        let active = true;
        setData(null);
        setDataSource(null);

        new ErpCalculationApi(authorityConfiguration)
            .dailyPaymentPerformance({
                projectId: project.id,
                dayInput: {
                    day: dayKey
                },
            })
            .then((nextData) => {
                if (!active) {
                    return;
                }

                setData(nextData);
            });

        return () => {
            active = false;
        };
    }, [dayKey, project.id]);

    let [labels, setLabels] = useState([]);
    let [dataSource, setDataSource] = useState(null);


    useEffect(() => {

        let newLabels = [];
        let newDataSource = [];

        // noinspection JSUnresolvedReference
        for (let payment of data?.payments ?? []) {
            if (payment.remoteId === 'default') {
                payment.name = t('orders.unresolved-payment');
            }

            newLabels.push(payment.name);
            newDataSource.push(payment.amount);
        }

        setLabels(newLabels);
        setDataSource(newDataSource);

    }, [data]);

    return (
        <LoadingComponent
            loading={data === null || dataSource === null}
            className={'col-span-12 sm:col-span-2 text-slate-600 dark:text-slate-400'}
        >
            <div
                className="comp__roundedBox reporting-surface rounded-lg inline-flex flex-col w-full text-sm bg-white dark:bg-slate-800 shadow-lg border border-slate-200 dark:border-slate-700">
                <div
                    className={'px-5 py-4 border-b border-slate-100 dark:border-slate-700 flex items-center'}>
                    <h2 className={'font-semibold text-slate-800 dark:text-slate-100'}>
                        {title}
                    </h2>
                </div>
                {dataSource !== null && data !== null &&
                    <DoughnutChart data={{
                        labels: labels,
                        datasets: [
                            {
                                data: dataSource,
                                backgroundColor: getContrastBackgroundColors(),
                                hoverBackgroundColor: getContrastBackgroundHoverColors(),
                                borderWidth: 0,
                            },
                        ],
                    }} height={200}/>
                }
            </div>
        </LoadingComponent>
    );
}
